import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, NgZone } from '@angular/core';
import { Router } from '@angular/router';
// import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
// import { ConfigLoaderService } from 'src/app/Shared/Services/Config/config-loader.service';
// import { ContactusService } from "src/app/Shared/Services/Contactus/contactus-service";
// import {  } from "src/app/Shared/Model/contactus/contactus-model";
// import { OfferingService } from 'src/app/Shared/Services/Offerings/offering.service'
import { ConfigLoaderService } from 'app/Shared/Services/Config/config-loader.service';
import { ContactusService } from 'app/Shared/Services/Contactus/contactus-service';
import { Contactus, UseCase, ClientIndustry, ClientMarket, FileDownloadpath } from 'app/Shared/Model/contactus/contactus-model';
import { OfferingService } from 'app/Shared/Services/Offerings/offering.service';

import { saveAs } from 'file-saver';
import { Offering } from '../../Model/offerings/offering.model';
import { isEmpty } from 'rxjs/operators';
declare var $: any;
import { ErrorModel } from '../../Model/error/error-model';
import { ErrorServiceService } from '../../Services/Error/error-service.service';
import { HttpEventType, HttpResponse, HttpClient } from '@angular/common/http';
import { DisclaimerComponent } from 'app/components/disclaimer/disclaimer.component';



@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalComponent implements OnInit {
  selectedoffering!: string;
  content: any;

  modalHeader!: string;
  modaldescription!: string;
  modalContent!: string;

  standardModuleHeader!: string;
  relatedLinksheader!: string;
  deliverables!: string;

  arrStandartModuleContents: any = [];
  arrrelatedLinksModuleContent: any = [];

  prereqDocketUrl!: string;
  prereqDocketname!: string;

  relDeckUrl!: any;
  relDeckName!: any;


  delDeckUrl!: string;
  delDeckName!: string;

  demoLink!: string;
  outputLink!: string;

  delOfflineName!: string;
  delOfflineurl!: string;

  modalDocketHeader!: string;
  modalDocketSubHeading!: string;

  contactmodel: Contactus = new Contactus();
  usecaselist!: UseCase[];
  clientmarketlist!: ClientMarket[];
  clientindustrylist!: ClientIndustry[];
  filepath!: FileDownloadpath;
  loading: any = false;
  @ViewChild('contactusform') form!: any;
  @ViewChild('closeModal') closeModal!: ElementRef
  showalertMsg: boolean = false;
  alertMsg!: string;
  alertmsgClass!: string;
  buttondisable: boolean = false;
  url: string = "";
  errModal!: ErrorModel;

  offering!: Offering[];
  shownote: boolean = false;
  showofferingDeck: boolean = true;
  showOutputDeck: boolean = true;
  offeringDeckText: string = 'Offerings Deck';
  filedownload = { status: '', progressPercent: '' };
  showFileDownloadInfo: boolean = false;

  showbuttonProceed: boolean = true;
  showAfterProceed: boolean = false;
  showDisclaimer: any = false;
  showDocketForm: any = false;


  // @ViewChild('frame') public formModal: any;
  // @ViewChild('scrollframe') public scrollModal: any;


  successMessage: string = "Thank you for downloading the Pre-requisite docket. Kindly contact the ASD Team if any assistance is required."
  errorMessage: string = "Error in  downloading the Pre-requisite docket. Kindly contact the ASD Team .";
  filedownloadMessage: string = "Docket Download is InProgress."
  filedownloadCompleteMessage: string = "Docket Download Completed"


  constructor(
    private router: Router,
    private _configLoaderService: ConfigLoaderService,
    private _offeringService: OfferingService,
    private _errorService: ErrorServiceService,
    private contactService: ContactusService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalComponent>,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    private dialog: MatDialog
  ) {
    this.filepath = new FileDownloadpath();
    this.errModal = new ErrorModel();
  }





  ngOnInit(): void {
    this.loading = true;
    if (ConfigLoaderService.settings.env.name == "DEVELOPMENT") {
      this.contactmodel.UserId = ConfigLoaderService.settings.DevValues.userName;
    }
    else {
      this.contactmodel.UserId = ConfigLoaderService.settings.AppSettings.userId;
    }
    this.selectedoffering = this.data.selectedoffering;
    this.errModal.UserId = this.contactmodel.UserId;
    this.errModal.ComponentName = "ModalComponent";
    this.standardModuleHeader = "Standard Module Coverage";
    this.relatedLinksheader = "Related Links";
    this.deliverables = "Deliverables";
    this.modalDocketHeader = "DOWNLOAD ASD –" + this.selectedoffering + " PRE-REQUISITE DOCKET";
    this.modalDocketSubHeading = "Kindly provide us with the following information to help us serve you better. Please click on Download after filling in the client details.";

    this.errModal.MethodName = "ngInit";
    this.errModal.ErrorMessage = "Error getting offering Details";


    this._offeringService
      .getOfferingDetailsOnAppType1(this.selectedoffering, this.contactmodel.UserId)
      .subscribe({
        next: (res: any) => {
          this.zone.run(() => {
            if (!res || !res[0] || this.isEmpty(res[0])) {
              this.dialogRef.close();
              this._errorService.handleError('', this.errModal);
              this.router.navigate(['/error']);
              return;
            }

            this.modalHeader = res[0]['HEADER'];
            this.modaldescription = res[0]['HEADER_DESCRIPTION'];

            this.arrStandartModuleContents =
              res[0]['STANDARD_MODULE_COVERAGE']
                ? res[0]['STANDARD_MODULE_COVERAGE'].split(',').map((x: string) => x.trim())
                : [];

            this.relDeckUrl = res[0]['OFFERING_DECK_URL'];
            this.demoLink = res[0]['DEMO_LINK'];
            this.prereqDocketname = res[0]['PREREQ_DOCKET_NAME'];
            this.prereqDocketUrl = res[0]['PREREQ_DOCKET_URL'];
            this.delDeckName = res[0]['SAMPLE_DECK_NAME'];
            this.delDeckUrl = res[0]['SAMPLE_DECK_URL'];
            this.delOfflineName = res[0]['SAMPLE_OFFLINE_NAME'];
            this.delOfflineurl = res[0]['SAMPLE_OFFLINE_URL'];
            this.outputLink = res[0]['OUTPUT_LINK'];

            if (
              this.selectedoffering === 'upstream' ||
              this.selectedoffering === 'utilities' ||
              this.selectedoffering === 'downstream'
            ) {
              this.shownote = true;
            }

            if (this.selectedoffering === 'srm') {
              this.showofferingDeck = false;
              this.showOutputDeck = false;
            }

            if (this.selectedoffering === 'apo') {
              this.showOutputDeck = false;
              this.offeringDeckText = 'Sample Output Deck (Prepared by the client team)';
            }

            this.loading = false;

            this.cdr.detectChanges();
          });
        },
        error: (error) => {
          this.zone.run(() => {
            this.loading = false;
            this.cdr.detectChanges();
            this._errorService.handleError(error, this.errModal);
          });
        }
      });
    ``

    this.getUsecaseList();
    this.getClientMarketList();
    this.getClientIndustryList();


  }


  onNavigate1(linkname: string) {


    if (linkname == "demoLink") {
      this.url = this.demoLink;
    }
    else if (linkname == "offering") {
      this.url = this.relDeckUrl;
    }
    else {
      this.url = this.outputLink;
    }
  }
  getUsecaseList() {
    this.errModal.MethodName = "GetUseCaseList";
    this.errModal.ErrorMessage = "Error getting UseCaseList";
    this.contactService
      .getUsecaseList(
        this.contactmodel.UserId
      )
      .subscribe(
        (data: any) => {
          if (data === undefined || data.length == 0) {
            this._errorService.handleError('', this.errModal)
          }
          else {
            this.usecaselist = data;
          }
        },
        (error) => {
          this._errorService.handleError(error, this.errModal)

        }
      );
  }

  getClientMarketList() {
    this.errModal.MethodName = "GetClientMarketList";
    this.errModal.ErrorMessage = "Error getting ClientMarketList";

    this.contactService
      .getClientMarketList(
        this.contactmodel.UserId
      )
      .subscribe(
        (data): any => {
          if (data === undefined || data.length == 0) {
            this._errorService.handleError('', this.errModal)
          }
          else {
            this.clientmarketlist = data;
          }
        },
        (error) => {
          this._errorService.handleError(error, this.errModal)
        }
      );
  }


  getClientIndustryList() {
    this.errModal.MethodName = "GetClientIndustryList";
    this.errModal.ErrorMessage = "Error getting ClientIndustryList";

    this.contactService
      .getClientIndustryList(
        this.contactmodel.UserId
      )
      .subscribe(
        (data: any) => {
          if (data === undefined || data.length == 0) {
            this._errorService.handleError('', this.errModal)
          }
          else {
            this.clientindustrylist = data;
          }
        },
        (error) => {
          this._errorService.handleError(error, this.errModal)
        }
      );
  }


  // onSubmit() {
  //   this.showFileDownloadInfo = true;
  //   this.errModal.MethodName = "Submit";
  //   this.errModal.ErrorMessage = "Error on Submitting Contact";

  //   this.contactmodel.AppType = this.selectedoffering.toUpperCase();

  //   this.contactService
  //     .submitDetails
  //     (
  //       this.contactmodel
  //     )
  //     .subscribe(
  //       (data: any) => {
  //         this.loading = true;

  //         $("#filedownloadsuccess").toast("show");
  //         this.alertmsgClass = 'alert alert-info';
  //         this.alertMsg = this.filedownloadMessage;
  //         this.showalertMsg = true;

  //         this.buttondisable = true;
  //         this.filepath.Filepath = data.body[0].filepath;
  //         this.filepath.Filename = data.body[0].filename;
  //         this.downloadFile('');

  //       },
  //       (error) => {
  //         this._errorService.handleError(error, this.errModal)
  //       }
  //     );

  // }


  downloadFile(linkName: string) {
    this.loading = true;
    this.showFileDownloadInfo = true;

    if (linkName === "OfferingDeck") {
      this.filepath.Filepath = this.relDeckUrl,
        this.filepath.Filename = this.relDeckName
    }
    else if (linkName === "OutputDeck") {
      this.filepath.Filepath = this.delDeckUrl,
        this.filepath.Filename = this.delDeckName
    }
    else if (linkName === 'offlineReport') {

      this.filepath.Filepath = this.delOfflineurl,
        this.filepath.Filename = this.delOfflineName

    }
    else {
      this.filepath.Filepath = this.prereqDocketUrl,
        this.filepath.Filename = this.prereqDocketname
    }

    this.contactService.getFile
      (
        this.filepath
      )
      .subscribe(
        (data) => {
          var message = this.getStatusMessage(data, linkName);
          if (message.toLowerCase() == "done") {
            this.filedownload.progressPercent = "100";
            this.loading = false;
            this.showFileDownloadInfo = false;
            $("#success").toast("show");
            this.alertmsgClass = 'alert alert-success';
            this.alertMsg = this.successMessage;
            this.showalertMsg = true;


            if (linkName == '') {
              this.formreset();
              this.buttondisable = false;

            }
          }

        },
        (err: any) => {
          this.errModal.ErrorMessage = "Erroron saving file";
          $("#error").toast("show");
          this.showFileDownloadInfo = false;
          this.loading = false;
          this.alertmsgClass = 'alert alert-danger';
          this.alertMsg = this.errorMessage;
          this.showalertMsg = true;
          if (linkName == '') {
            this.formreset();
            this.buttondisable = false;
          }
          this._errorService.handleError(err, this.errModal)
        }
      );
  }

  getStatusMessage(event: any, linkName: string) {
    let status;

    switch (event.type) {

      case HttpEventType.DownloadProgress:


        status = Math.round(100 * event.loaded / event.total);
        this.filedownload.status = "InProgress"
        this.filedownload.progressPercent = status.toString();
        $("#filedownloadmodalsuccess").toast("show");
        this.alertmsgClass = 'alert alert-info';
        if (linkName == '') {
          this.alertMsg = this.filedownloadMessage
        }
        else {
          this.alertMsg = "Report Download is InProgress";
        }

        this.showalertMsg = true;

        return 'Files are ' + status + '% downloaded';

      case HttpEventType.Response:
        this.generateDownload(event.body!, linkName)
        return 'Done';

      default:
        return 'Something went wrong'
    }
  }

  generateDownload(data: Blob, linkName: string) {
    saveAs(data, this.filepath.Filename); // from file-saver library 
  }



  // OpenDisclaimerpopup() {
  //   this.formModal.show();

  // }

  // openScrollDocket() {
  //   this.scrollModal.show();
  //   this.formModal.hide();
  // }

  // OpenDisclaimerpopup(): void {
  //   this.showDisclaimer = true;
  //   this.showDocketForm = false;
  //   this.cdr.detectChanges();
  // }
OpenDisclaimerpopup(): void {

  this.dialog.open(DisclaimerComponent, {
    width: '1150px',
    maxWidth: '95vw',
    data: {
      selectedoffering: this.selectedoffering,
      prereqDocketUrl: this.prereqDocketUrl,
      prereqDocketname: this.prereqDocketname
    }
  });

}

  openScrollDocket(): void {
    this.showDisclaimer = false;
    this.showDocketForm = true;
    this.cdr.detectChanges();
  }


  closeAlert() {
    this.showalertMsg = false;
  }

  formreset() {
    this.form.resetForm();
    this.form.controls.clientmarket.setValue('');
    this.form.controls.clientindustry.setValue('');
    this.form.controls.usecase.setValue('');
  }

  isEmpty(obj: any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  closeDialog() {
    // console.log('Closing:', this.selectedoffering);
    document.body.classList.remove('modal-open');
    this.dialogRef.close();
  }





}
